import React from 'react';

type SkeletonListProps<T extends React.ElementType> = {
  SkeletonComponent: T;
  componentProps?: React.ComponentProps<T>;
  count?: number;
};

export const SkeletonList = <T extends React.ElementType>({
  SkeletonComponent,
  componentProps,
  count = 3,
}: SkeletonListProps<T>) => {
  return (
    <ul>
      {Array.from({ length: count }, (_, i) => (
        <li key={i}>
          <SkeletonComponent {...componentProps} />
        </li>
      ))}
    </ul>
  );
};
